import { Injectable } from '@angular/core';
@Injectable()
export class ThemeService {

  constructor() {
  }

  setTheme(theme: string) {
    this.setBodyThemeAttribute(theme);
    window.localStorage.setItem('theme', theme);
  }

  getTheme() {
    let theme = window.localStorage.getItem('theme');
    if (!theme) {
      theme = "light";
    }
    this.setBodyThemeAttribute(theme);
    return theme;
  }

  private setBodyThemeAttribute(theme: string) {
    const body = document.getElementsByTagName('body')[0];
    if (body.getAttribute("theme-skin") !== theme) {
      body.setAttribute("theme-skin", theme);
    }
  }

}
